<template>
  <div class="event-detail">
    <div class="detail-inner">
      <div class="content-col">
        <h1 class="event-title">{{ item.title }}</h1>
        <img v-if="item.downloadUrl" class="top-img" v-bind:src="item.downloadUrl" alt="">
        <div class="content-title">内容</div>
        <div class="content" v-html="autoLink(item.content)"></div>
        <img v-if="item.downloadUrl2" class="top-img top-img-2" v-bind:src="item.downloadUrl2" alt="">
        <div class="content" v-html="autoLink(item.content2)"></div>
        <div v-if="item.priceDispFlag == false && item.applicationUrl" class="apply-wrap">
          <a class="application_url" v-bind:href="item.applicationUrl" target="_blank">申し込みはこちら</a>
        </div>
      </div>

      <aside v-if="item.priceDispFlag == true" class="price-card">
        <div class="price-card-title">価格</div>
        <div class="price-list">
          <div class="price-row" v-if="item.premiumPrice != ''">
            <span class="price-name">{{ item.premiumLabel ? item.premiumLabel : 'プレミアム会員価格' }}</span>
            <span class="price-amount">{{ item.premiumPriceNum == 0 ? '無料' : '¥' + item.premiumPriceLocalString }}</span>
            <button class="apply-btn" @click="sendPay(item.premiumUrl)">申込</button>
          </div>
          <div class="price-row" v-if="item.basicPrice != ''">
            <span class="price-name">{{ item.basicLabel ? item.basicLabel : 'ベーシック会員価格' }}</span>
            <span class="price-amount">{{ item.basicPriceNum == 0 ? '無料' : '¥' + item.basicPriceLocalString }}</span>
            <button class="apply-btn" @click="sendPay(item.basicUrl)">申込</button>
          </div>
          <div class="price-row" v-if="item.otherPrice != ''">
            <span class="price-name">{{ item.otherLabel ? item.otherLabel : 'サポーター＆非会員価格' }}</span>
            <span class="price-amount">{{ item.otherPriceNum == 0 ? '無料' : '¥' + item.otherPriceLocalString }}</span>
            <button class="apply-btn" @click="sendPay(item.otherUrl)">申込</button>
          </div>
          <div class="price-row" v-if="item.studentPrice > 0">
            <span class="price-name">{{ item.studentLabel ? item.studentLabel : '小中高価格' }}</span>
            <span class="price-amount">¥{{ item.studentPriceLocalString }}</span>
            <button class="apply-btn" @click="sendPay(item.studentUrl)">申込</button>
          </div>
          <div class="price-row" v-if="item.elementaryStudentPrice > 0">
            <span class="price-name">{{ item.elementaryStudentLabel ? item.elementaryStudentLabel : '小学生価格' }}</span>
            <span class="price-amount">¥{{ item.elementaryStudentPriceLocalString }}</span>
            <button class="apply-btn" @click="sendPay(item.elementaryStudentUrl)">申込</button>
          </div>
          <div class="price-row" v-if="item.babyPrice > 0">
            <span class="price-name">{{ item.babyLabel ? item.babyLabel : '未就学児価格' }}</span>
            <span class="price-amount">¥{{ item.babyPriceLocalString }}</span>
            <button class="apply-btn" @click="sendPay(item.babyUrl)">申込</button>
          </div>
        </div>
      </aside>
    </div>
  </div>
</template>

<script>
import firebase from "../main.js"
import { doc, getDoc } from "firebase/firestore";

export default {
  components: {
  },
  data() {
    return {
      id: null,
      item: {},
      loading: false,
      lineItems: [
        {
          price: "prod_MBRAl9jqT2tGWY",
          quantity: 1
        }
      ],
    }
  },
  props: {
  },
  created() {
    this.id = this.$route.query.id;
  },
  mounted() {
    this.awaitFunc();
  },
  methods: {
    async awaitFunc() {
      const docRef = doc(firebase.db, "Events", this.id);
      const querySnapshot = await getDoc(docRef);
      const docData = querySnapshot.data();
      this.item = docData;
      this.item.premiumPriceNum = Number(docData.premiumPrice);
      this.item.premiumPriceLocalString = Number(docData.premiumPrice).toLocaleString();

      this.item.basicPriceNum = Number(docData.basicPrice);
      this.item.basicPriceLocalString = Number(docData.basicPrice).toLocaleString();

      this.item.otherPriceNum = Number(docData.otherPrice);
      this.item.otherPriceLocalString = Number(docData.otherPrice).toLocaleString();

      this.item.studentPriceNum = Number(docData.studentPrice);
      this.item.studentPriceLocalString = Number(docData.studentPrice).toLocaleString();

      this.item.elementaryStudentPriceNum = docData.elementaryStudentPrice ? Number(docData.elementaryStudentPrice) : 0;
      this.item.elementaryStudentPriceLocalString = docData.elementaryStudentPrice ? Number(docData.elementaryStudentPrice).toLocaleString() : 0;

      this.item.babyPriceNum = Number(docData.babyPrice);
      this.item.babyPriceLocalString = Number(docData.babyPrice).toLocaleString();

      if (!("priceDispFlag" in this.item)) {
        this.item.priceDispFlag = true;
      }

      if (this.item.content.indexOf("gagagagazou") >= 0) {
        let contents = this.item.content.split("gagagagazou");
        this.item.content = contents[0];
        this.item.content2 = contents[1];
      }

      this.downloadUrl();
      this.downloadUrl2();
    },
    sendPay(url) {
      window.open(url, '_blank');
    },
    async downloadUrl() {
      if (this.item.imageurl) {
        const bucket = "farmy-demo.appspot.com";
        const path = encodeURIComponent("events-contents-image/" + this.item.imageurl);
        this.item.downloadUrl = `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${path}?alt=media`;
      }
    },
    async downloadUrl2() {
      if (this.item.imageurl2) {
        const bucket = "farmy-demo.appspot.com";
        const path = encodeURIComponent("events-contents-image/" + this.item.imageurl2);
        this.item.downloadUrl2 = `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${path}?alt=media`;
      }
    },
    autoLink(text) {
      return text ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1' style='color:#AF9453;text-decoration:underline;' target='_blank'>$1</a>") : '';
    },
  }
}
</script>

<style scoped>
.event-detail {
  padding: 28px 16px 64px;
}
.detail-inner {
  max-width: 1040px;
  margin: 0 auto;
  display: flex;
  gap: 32px;
  align-items: flex-start;
}

/* 本文 */
.content-col {
  flex: 1;
  min-width: 0;
  text-align: left;
}
.event-title {
  color: #AF9453;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.5;
  margin-bottom: 18px;
}
.top-img {
  width: 100%;
  max-height: 440px;
  object-fit: cover;
  border-radius: 12px;
  display: block;
}
.top-img-2 {
  margin-top: 20px;
}
.content-title {
  color: #AF9453;
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  letter-spacing: 0.1em;
  margin: 30px 0 16px;
}
.content {
  white-space: pre-line;
  text-align: left;
  font-size: 15px;
  line-height: 1.95;
  color: #4a463f;
}
.apply-wrap {
  text-align: center;
  margin: 36px 0 8px;
}
.application_url {
  display: inline-block;
  background-color: #AF9453;
  color: #fff;
  padding: 14px 44px;
  border-radius: 999px;
  font-size: 16px;
  font-weight: 700;
  text-decoration: none;
  transition: filter 0.15s, transform 0.15s;
}
.application_url:hover {
  filter: brightness(1.07);
  transform: translateY(-1px);
}

/* 価格カード */
.price-card {
  position: sticky;
  top: 20px;
  width: 300px;
  flex-shrink: 0;
  background: #fff;
  border: 1px solid #e8dfc9;
  border-radius: 14px;
  box-shadow: 0 6px 22px rgba(0, 0, 0, 0.07);
  padding: 20px 18px;
}
.price-card-title {
  text-align: center;
  font-size: 15px;
  font-weight: 700;
  color: #937b3f;
  letter-spacing: 0.18em;
  padding-bottom: 12px;
  border-bottom: 2px solid #f0ece1;
}
.price-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 13px 2px;
  border-bottom: 1px solid #f4efe2;
}
.price-name {
  flex: 1;
  font-size: 13px;
  color: #6b6555;
  line-height: 1.4;
}
.price-amount {
  font-size: 15px;
  font-weight: 700;
  color: #433f38;
  white-space: nowrap;
}
.apply-btn {
  flex-shrink: 0;
  background: #AF9453;
  color: #fff;
  border: none;
  padding: 6px 15px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: filter 0.15s;
}
.apply-btn:hover {
  filter: brightness(1.08);
}

@media screen and (max-width: 820px) {
  .detail-inner {
    flex-direction: column;
  }
  .content-col {
    width: 100%;
  }
  .price-card {
    position: static;
    width: 100%;
    order: -1;
    margin-bottom: 8px;
  }
  .top-img {
    max-height: 260px;
  }
}
</style>
